module.exports = __webpack_public_path__ + "static/pipeline-update-category_1-ba5cfeccef8d88bb977c2b9443d680cb.png";